import React from 'react';

import {CustomImage, Richtext, TextCustom} from '@vw-marketing/us-components';

import {AppConstants} from '../../../utils/app-constants';
import {clearText} from '../../../utils/general';
import {descriptionOverrides, vinTextStyle} from './helpers';
import {ModalHandOffTranslations} from '../../../typing/translations';
import {UsedVehicle} from '../../../typing/used-inventory';
import {useFeatureAppConfig} from '../../../hooks/use-feature-app-config';
import {
  StyledDealerCardContainer,
  StyledDealerCardImageContainer,
  StyledDealerCardLabel,
  StyledVehicleVINLabel,
} from './styles';

interface InterstitialCarCardProps {
  vehicle: UsedVehicle;
  translations: ModalHandOffTranslations;
  currency?: string;
}

export const InterstitialCarCard = ({
  vehicle,
  translations,
}: InterstitialCarCardProps) => {
  const {faHostServerUrl = ''} = useFeatureAppConfig();
  const noFoundImage = AppConstants.NoVehicleImage;

  const modelDescription = translations.dealerStepCard.title.replace(
    '$$modelName$$',
    `${vehicle.modelYear} ${vehicle.model} ${clearText(vehicle.trimLevel)}`,
  );

  return (
    <StyledDealerCardContainer className="dealer-card">
      <StyledDealerCardLabel className="dealer-card-label notranslate">
        <Richtext
          markdown={modelDescription}
          overrides={descriptionOverrides}
          dangerouslyParseRawHTML
        />
      </StyledDealerCardLabel>
      <StyledVehicleVINLabel className="dealer-card-vin notranslate">
        <TextCustom {...vinTextStyle}>VIN {vehicle.vin}</TextCustom>
      </StyledVehicleVINLabel>
      <StyledDealerCardImageContainer className="dealer-card-image">
        <CustomImage
          src={vehicle.mediaImageUrl!}
          alt={vehicle.model || faHostServerUrl + noFoundImage}
          srcPlaceholder={AppConstants.PlaceHolder480x216}
          srcErrorImage={noFoundImage}
        />
      </StyledDealerCardImageContainer>
    </StyledDealerCardContainer>
  );
};
